// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { locationFinderStyles } from "@insite/content-library/Widgets/LocationFinder/LocationFinder";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

locationFinderStyles.rightColumnGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        .gm-style-iw-d {
            overflow: auto !important;
            padding-right: 12px;
            padding-bottom: 12px;
        }
        ${xScreen("lte", "md")} {
            order: 1;
        }
    `,
};
